/**
 * IMPORTS
 */

import { remessaDownloadPlanilhaRepository } from "@/repositories/remessas/remessa-planilha-download";

/**
 * Função que faz o download planilha da remessa 🛠️.
 */
const handleGetDownloadPlanilhaRemessa = async (
  accessToken: string,
  remessa_id: number,
  planilhaNome: string
) => {
  try {
    const data = await remessaDownloadPlanilhaRepository.getDownloadPlanilhaRemessa(
      accessToken,
      remessa_id,
      planilhaNome
    );

    return data;
  } catch (error) {
    return error;
  }
};

/**
 * EXPORTS
 */
export { handleGetDownloadPlanilhaRemessa };
